<template>
  <b-modal
    id="modal-nueva-noticia"
    centered
    title="Nueva Noticia"
    ok-title="GUARDAR"
    cancel-title="CANCELAR"
    cancel-variant="outline-secondary"
    v-model="$store.state.someVariables.showNewNoticia"
  >
    <b-form>
      <div class="form-label-group">
        <b-form-input
          id="floating-titulo"
          placeholder="Ingrese Título *"
          v-model="dataNoticia.titulo"
          class="mt-1"
        />
        <label for="floating-titulo">Título</label>
      </div>
      <div class="form-label-group">
        <b-form-input
          id="floating-link"
          placeholder="Ingrese Link (Opcional)"
          v-model="dataNoticia.link"
          class="mt-2"
        />
        <label for="floating-link">link</label>
      </div>

      <!-- <b-form-group label="Contenido:" label-for="tituloNoticia">
        <b-form-input
          id="tituloNoticia"
          :state="tieneErrorTitulo"
          v-model="inputTitulo"
        />
        <b-form-invalid-feedback>
          {{ mensajeErrorTitulo }}
        </b-form-invalid-feedback>
      </b-form-group> -->

      <label for="textarea-default">Contenido</label>
      <b-form-textarea
        v-model="dataNoticia.descripcion"
        id="textarea-default"
        placeholder="Textarea"
        rows="3"
      />
    </b-form>
    <div class="demo-inline-spacing">
      <b-form-radio v-model="selected" name="some-radios" value="F">
        Imagen
      </b-form-radio>
      <b-form-radio v-model="selected" name="some-radios" value="V">
        Video
      </b-form-radio>
    </div>
    <croppa
      v-if="selected == 'F'"
      v-model="croppaFoto"
      :width="370"
      :height="250"
      placeholder="seleccionar Foto"
      placeholder-color="#543338"
      :placeholder-font-size="16"
      canvas-color="transparent"
      :show-remove-button="true"
      remove-button-color="black"
      :show-loading="false"
      :loading-size="50"
      loading-color="#606060"
      :quality="1"
      class="mt-1"
    ></croppa>
    <template v-if="selected == 'V'">
      <b-form-file
        v-model="fileModel"
        placeholder="Selecciona o arrastra un video"
        drop-placeholder="Arrastra un video"
        accept=".mp4"
        @change="cambioFile"
        class="mt-1"
      />
      <div class="d-flex justify-content-center">
        <video
          width="85%"
          id="video"
          controls="controls"
          crossorigin
          class="mt-1"
        ></video>
      </div>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="float-right mt-1"
        @click="capturaPortada"
        size="sm"
      >
        Capturar portada para noticia
      </b-button>
      <div style="text-align:center">
        <canvas width="370" height="250" id="canvasFotoVideo" class="mt-1">
        </canvas>
      </div>
    </template>
    <template #modal-footer>
      <div class="w-100">
        <template v-if="!showLoading">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right"
            @click="uploadNoticia"
          >
            Publicar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="onlyClose"
          >
            Cancelar
          </b-button>
        </template>
        <div v-if="showLoading" class="text-center mt-1">
          <b-spinner variant="primary" label="Text Centered" />
          <span>por favor espera, esto puede tardar unos segundos</span>
        </div>
        <b-alert
          :show="dismissCountDown"
          v-height-fade.appear
          :variant="variante"
          style="position:absolute; bottom:55px;  width:92%; margin-left:-4px ;z-index:100"
          @dismiss-count-down="countDownChanged"
        >
          <div
            :class="{
              'alert-body danger': variante == 'danger',
              'alert-body success': variante == 'success',
            }"
          >
            {{ messageError }}
          </div>
        </b-alert>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BModal,
  BForm,
  BFormInput,
  //   BFormGroup,
  //   BFormInvalidFeedback,
  //   BFormValidFeedback,
  BFormTextarea,
  BFormRadio,
  BFormFile,
  BButton,
  BSpinner,
  BAlert,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { heightFade } from '@core/directives/animations'
import store from '@/store'
import {
  URL,
  //   USER,
  //   ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    // BFormGroup,
    // BFormInvalidFeedback,
    // BFormValidFeedback,
    BFormTextarea,
    BFormRadio,
    BFormFile,
    BButton,
    BSpinner,
    BAlert,
  },
  directives: {
    Ripple,
    heightFade,
  },
  setup(props, { emit }) {
    const tieneErrorTitulo = ref(null)
    const mensajeErrorTitulo = ref('')
    const selected = ref(null)
    const inputTitulo = ref('')
    const croppaFoto = ref({})
    const file = ref(false)
    const dismissCountDown = ref(0)
    const dismissSecs = ref(3)
    const messageError = ref('')
    const variante = ref('danger')
    const showLoading = ref(false)
    const hasError = ref(false)
    const fileModel = ref(null)
    const capturada = ref(false)
    const { postApiFormData } = apiCall()
    const dataNoticia = ref({
      titulo: '',
      link: '',
      descripcion: '',
      es_video: 'n',
      id_torneo: '0',
    })

    function fotoPortada() {
      const canvas = document.getElementById('canvasFotoVideo')
      let data = null
      // console.log(canvas)
      if (canvas != null) {
        data = canvas.toDataURL()
      }
      return data
    }
    function showMessageAlert(type, mensaje) {
      variante.value = type
      hasError.value = true
      messageError.value = mensaje
      dismissCountDown.value = dismissSecs.value
    }
    function countDownChanged(dismissCountDownAux) {
      dismissCountDown.value = dismissCountDownAux
    }
    function getPicturePlayer(croppa) {
      let fotografia = ''
      if (croppa.value.chosenFile == null) {
        fotografia = ''
      } else {
        const fotografiaBase64 = croppa.value.generateDataUrl(
          'image/jpeg',
          // eslint-disable-next-line
          0.5
        )
        fotografia = fotografiaBase64
      }
      return fotografia
    }
    function resetForm() {
      dataNoticia.value = {
        titulo: '',
        link: '',
        descripcion: '',
        es_video: 'n',
        id_torneo: '0',
      }
      capturada.value = false
      fileModel.value = null
      const canvas = document.getElementById('canvasFotoVideo')
      if (canvas != null) {
        canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height)
        const videoNode = document.querySelector('video')
        videoNode.src = null
      }
      selected.value = null
    }
    function errorTipo() {
      let error = false
      if (selected.value === 'F') {
        dataNoticia.value.es_video = 'n'
        const foto64 = getPicturePlayer(croppaFoto)
        if (foto64 === '') {
          showMessageAlert('danger', 'Debes seleccionar una fotografía')
          error = true
        }
      } else if (selected.value === 'V') {
        dataNoticia.value.es_video = 's'
        if (fileModel.value === null) {
          showMessageAlert('danger', 'Debes seleccionar un video')
          error = true
        } else if (fileModel.value !== null) {
          if (!capturada.value) {
            showMessageAlert('danger', 'Debes capturar alguna imagen del video')
            error = true
          }
        }
      }
      return error
    }
    function hasErrorForm() {
      let error = false
      // console.log(dataNoticia)
      if (dataNoticia.value.titulo === '') {
        showMessageAlert('danger', 'Título no debe ser vacío')
        error = true
      } else if (dataNoticia.value.descripcion === '') {
        showMessageAlert('danger', 'Descripción no debe ser vacío')
        error = true
      } else if (errorTipo()) {
        error = true
      }
      return error
    }
    async function uploadNoticia() {
      if (!hasErrorForm()) {
        showLoading.value = true
        const archivo = new FormData()
        // console.log(dataNoticia)
        archivo.append('file', fileModel.value)
        archivo.append('titulo', dataNoticia.value.titulo)
        archivo.append('link', dataNoticia.value.link)
        archivo.append('descripcion', dataNoticia.value.descripcion)
        archivo.append('es_video', dataNoticia.value.es_video)
        archivo.append('id_torneo', store.getters['someVariables/getTorneoSeleccionado'].id_torneo)
        archivo.append('portada', fotoPortada())
        archivo.append('fotografia', getPicturePlayer(croppaFoto))
        const path = 'ApiNoticias/saveNoticia'
        const response = await postApiFormData(URL, path, archivo)
        if (response.flag === 'si') {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'PUBLICADA con éxito',
                icon: 'AlertCircleIcon',
                variant: 'success',
                solid: true,
              },
            },
            {
              position: 'bottom-center',
              // eslint-disable-next-line
            }
          )
          emit('recargar')
          resetForm()
        }
        showLoading.value = false
      }
    }

    function capturaPortada() {
      const canvas = document.getElementById('canvasFotoVideo')
      const video = document.getElementById('video')
      canvas
        .getContext('2d')
        .drawImage(video, 0, 0, canvas.width, canvas.height)
      capturada.value = true
    }

    function cambioFile(evt) {
      const tgt = evt.target || window.event.srcElement
      //   const file = tgt.files[0]
      // console.log(tgt.files.length)
      if (tgt.files.length === 0) {
        file.value = false
        const canvas = document.getElementById('canvasFotoVideo')
        canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height)
        const videoNode = document.querySelector('video')
        videoNode.src = null
        capturada.value = false
      } else {
        // eslint-disable-next-line
        file.value = true
        const videoNode = document.querySelector('video')
        const fileURL = window.URL.createObjectURL(tgt.files[0])
        videoNode.src = fileURL
      }

      //   function saveNew() {}
      //   console.log('tgt', tgt.files)
    }
    function onlyClose() {
      //   store.commit('someVariables/UPDATE_SHOW_NEW_PLAYER', false)
      showLoading.value = false
    }
    return {
      tieneErrorTitulo,
      mensajeErrorTitulo,
      inputTitulo,
      uploadNoticia,
      selected,
      croppaFoto,
      cambioFile,
      file,
      capturaPortada,
      dismissCountDown,
      dismissSecs,
      countDownChanged,
      messageError,
      variante,
      showLoading,
      hasError,
      showMessageAlert,
      dataNoticia,
      onlyClose,
      fileModel,
    }
  },
}
</script>
<style>
.danger {
  background-color: #ea5454c7;
  border-radius: 5px;
  color: white;
}
.success {
  background-color: #2be025c7;
  border-radius: 5px;
  color: white;
}
</style>
